/*
@创建人: lfq
@联系Qq:1638245306
@创建时间: 2020-05-30 11:36:29
@文件介绍: 桥梁养护决策
*/
export default [{
    path: 'bridgePlanning',
    name: 'bridgePlanning',
    meta: {
        title: '桥梁规划管理',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/bridgePlanning/table')
},{
    path: 'maintainType',
    name: 'maintainType',
    meta: {
        title: '养护类型确定',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/maintainType/table')
},{
    path: 'fundingPlan',
    name: 'fundingPlan',
    meta: {
        title: '养护资金规划',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/fundingPlan/table')
},{
    path: 'pmdMlSpecification',
    name: 'pmdMlSpecification',
    meta: {
        title: '养护级别规划对应',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/parameterLibrary/pmdMlSpecification')
},{
    path: 'pmdWeightCoefficient',
    name: 'pmdWeightCoefficient',
    meta: {
        title: '整体权重系数',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/parameterLibrary/pmdWeightCoefficient')
},{
    path: 'objectSelect',
    name: 'objectSelect',
    meta: {
        title: '项目级决策',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/objectAnalysis/table')
}, {
    path: 'networkSelect',
    name: 'networkSelect',
    meta: {
        title: '网级决策',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/projectDecision/networkAnalysis/table')
},{
    path: 'planningManagement',
    name: 'planningManagement',
    meta: {
        title: '隧道规划管理',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/tunnelDecision/planningManagement')
},{
    path: 'tunnelMaintainType',
    name: 'tunnelMaintainType',
    meta: {
        title: '隧道养护类型制定',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/tunnelDecision/maintainType')
},{
    path: 'tunnelFundingPlan',
    name: 'tunnelFundingPlan',
    meta: {
        title: '隧道资金规划',
        auth: true
    },
    component: () =>
        import ('@/views/bridgeMaintenanceDecision/tunnelDecision/fundingPlan')
}]










